import React, { memo, useContext, useEffect, useState } from 'react'

import { InputField, InputLocalization, Modal } from '../../../components/common'
import { LanguageContext } from '../../../context/LanguageContext'
import { util } from '../../../util'

const EditTitleModal = ({
    modalTitle,
    closeEditModal,
    modalClose,
    title,
    localizations,
    titleInputProps,
    onSaveClickHandler,
    isModalLoading,
}) => {
    const { customerWebLanguages, strings } = useContext(LanguageContext)

    const [editTitle, setEditTitle] = useState(title)
    const [editTitleLocalizations, setEditTitleLocalizations] = useState({ localizations })
    const isSaveBtnEnabled = () => {
        let validTitle = util.regexString(editTitle)
        if (!validTitle || !validTitle.length) return false
        if (validTitle !== title) return true

        const _getLocalizedTitle = (localization, lang) => {
            let localizedTitle = localization
            if (localizedTitle) {
                localizedTitle = localizedTitle[lang]
                if (localizedTitle) {
                    localizedTitle = localizedTitle.title
                    if (localizedTitle) localizedTitle = util.regexString(localizedTitle)
                }
            }
            return localizedTitle
        }
        let newTitleLocalization = false
        for (const lang in editTitleLocalizations.localizations) {
            const newLocalizedTitle = _getLocalizedTitle(editTitleLocalizations.localizations, lang)

            const oldLocalizedTitle = _getLocalizedTitle(localizations, lang)

            if (!!(newLocalizedTitle && newLocalizedTitle !== oldLocalizedTitle)) {
                newTitleLocalization = true
                break
            }
        }

        return newTitleLocalization
    }

    useEffect(() => {
        modalClose && closeEditModal()
        return () => closeEditModal()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalClose])

    const changeHandler = e => {
        setEditTitle(e.target.value)
    }

    const saveClickHandler = () => {
        onSaveClickHandler(editTitle, editTitleLocalizations.localizations)
    }

    const header = <Modal.Heading heading={modalTitle} cancelModalHandler={closeEditModal} />

    const content = (
        <div className={'content'}>
            <InputField
                value={editTitle}
                onChange={changeHandler}
                type={'text'}
                size={'xl'}
                required
                name={'edit title'}
                {...titleInputProps}
            />
            {localizations && (
                <div className={'edit-title-modal__input-localizations'}>
                    <InputLocalization
                        fieldKey={'title'}
                        languages={customerWebLanguages.languages}
                        localizations={editTitleLocalizations.localizations}
                        setState={setEditTitleLocalizations}
                        languageSection={({ index, label, onChange, value }) => (
                            <InputField
                                key={index}
                                {...titleInputProps}
                                className={'input-localizations__field'}
                                isFullWidth
                                label={label}
                                size={'xl'}
                                onChange={onChange}
                                type={'text'}
                                value={value}
                            />
                        )}
                    />
                </div>
            )}
        </div>
    )

    const actions = (
        <Modal.Actions
            color={isSaveBtnEnabled() ? 'primary' : 'disabled'}
            cancelModalHandler={closeEditModal}
            saveClickHandler={saveClickHandler}
            submitBtn={strings.SAVE}
            cancelBtn={strings.CANCEL}
            disabledBtn={!isSaveBtnEnabled()}
            size={'xl'}
        />
    )

    return (
        <Modal
            data-testid={'edit-title-modal'}
            size={localizations ? 'md' : 'sm'}
            header={header}
            content={content}
            actions={actions}
            loading={isModalLoading}
        />
    )
}

export default memo(EditTitleModal)
